import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3661 7.36612C16.8543 6.87796 17.6457 6.87796 18.1339 7.36612L21.8839 11.1161C22.372 11.6043 22.372 12.3957 21.8839 12.8839L18.1339 16.6339C17.6457 17.122 16.8543 17.122 16.3661 16.6339C15.878 16.1457 15.878 15.3543 16.3661 14.8661L17.9822 13.25H3C2.30964 13.25 1.75 12.6904 1.75 12C1.75 11.3096 2.30964 10.75 3 10.75H17.9822L16.3661 9.13388C15.878 8.64573 15.878 7.85427 16.3661 7.36612Z"
        fill={colorValue}
      />
    </svg>
  );
};
